import React from 'react'
import { FormattedMessage } from 'react-intl'
import { useAgency } from '../../hooks/use-agency'
import { getThemeColor } from '../../theming/helpers'
import { maplibre, MAPTILER_TOKEN } from '../../utils/maps'
import { Modal } from '../modal'

export function MapModal({ property, isOpen, onClose }) {
  const coordinates = property.attributes.location.geo

  if (!coordinates) {
    return null
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={<FormattedMessage id="location" />}
    >
      <SimpleMap coordinates={coordinates} />
    </Modal>
  )
}

function SimpleMap({ coordinates }) {
  const { settings } = useAgency()
  const ref = React.useRef()
  React.useEffect(() => {
    const map = new maplibre.Map({
      container: ref.current,
      style: `https://api.maptiler.com/maps/streets-v2/style.json?key=${MAPTILER_TOKEN}`,
      pitchWithRotate: false,
      touchPitch: false,
      center: {
        lat: coordinates.latitude,
        lng: coordinates.longitude,
      },
      zoom: 18,
    })

    map.addControl(new maplibre.NavigationControl())
    new maplibre.Marker({ color: getThemeColor(settings) })
      .setLngLat({
        lat: coordinates.latitude,
        lng: coordinates.longitude,
      })
      .addTo(map)
  }, [])

  return (
    <div
      ref={ref}
      className="propertyMap"
      style={{
        width: '100%',
        height: '100%',
        minHeight: '60vh',
        position: 'relative',
        overflow: 'hidden',
      }}
    />
  )
}
